import React from 'react'
import '../styles/Nosotros/TeamAbout.css'
/*images*/
import Mail from '@mui/icons-material/MailOutline';
import PhoneTalk from '@mui/icons-material/PhoneInTalkOutlined';

import { useTranslation } from 'react-i18next';

function TeamAbout() {
    const {t} = useTranslation();

  return (
    <>
    <div className='conoce-nuestro-equipo'>
      <h3 style={{color: '#421831', fontFamily: 'Outfit, sans-serif', fontWeight: '700', fontStyle: 'normal'}}>{t("our_team")}</h3>
    </div>
    <section className="aboutTeam">
      <div className='card-container'>
          <div className="aboutTeam-container">
              <h3>Maria Fernanda Pareja</h3>
          </div>
          <div className="aboutTeam-info">
              <h5>{t("team_1")}</h5>
              <p><Mail style={{ fontSize: 20, marginRight: 5 }} />mariafpareja@nutrimarketchemicals.com</p>
              <p><PhoneTalk style={{ fontSize: 20, marginRight: 5}} />+57 317 5178521</p>
          </div>
      </div>
      <div className='card-container'>
          <div className="aboutTeam-container">
              <h3>Sonia Torres</h3>
          </div>
          <div className="aboutTeam-info">
              <h5>{t("team_4")}</h5>
              <p><Mail style={{ fontSize: 20, marginRight: 5 }} />sonia.torres@nutrimarketchemicals.com</p>
              <p><PhoneTalk style={{ fontSize: 20, marginRight: 5}} />+57 316 4647060</p>
          </div>
      </div>
      <div className='card-container'>
          <div className="aboutTeam-container">
              <h3>Ana Carolina Chavarro</h3>
          </div>
          <div className="aboutTeam-info">
              <h5>{t("team_2")}</h5>
              <p><Mail style={{ fontSize: 20, marginRight: 5 }} />ventas@nutrimarketchemicals.com</p>
              <p><PhoneTalk style={{ fontSize: 20, marginRight: 5}} />+57 316 5239821</p>
          </div>
      </div>
      <div className='card-container'>
          <div className="aboutTeam-container">
              <h3>Yeimy Cordoba</h3>
          </div>
          <div className="aboutTeam-info">
              <h5>{t("team_5")}</h5>
              <p><Mail style={{ fontSize: 20, marginRight: 5 }} />ventas2@nutrimarketchemicals.com</p>
              <p><PhoneTalk style={{ fontSize: 20, marginRight: 5}} />+57 322 9232412</p>
          </div>
      </div>
      <div className='card-container'>
          <div className="aboutTeam-container">
              <h3>Rodrigo Bouvet</h3>
          </div>
          <div className="aboutTeam-info">
              <h5>{t("team_3")}</h5>
              <p><Mail style={{ fontSize: 20, marginRight: 5 }} />comercial2@nutrimarketchemicals.com</p>
              <p><PhoneTalk style={{ fontSize: 20, marginRight: 5}} />+54 344 7447694</p>
          </div>
      </div>   
    </section>
    </>
  )
}

export default TeamAbout